import { TranslationModule } from "../../translation/translation.module";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { GlobalModule } from "../../Global/global.module";

import { RouterLink } from "@angular/router";
import { HomeComponent } from "./home.component";
import {
  AccueilSetyCoreComponent,
  AssistanceComponent as AssistanceComponentBib,
  ContactComponent as ContactComponentLib,
  StoresComponent as StoresComponentLib,
  ChangePasswordComponent,
  ModalComponent,
  BrandsComponent,
  SnackbarComponent,
  AddProductPopupSetycoreComponent,
} from "admin-common";
import { AssistanceComponent } from "./assistance/assistance.component";
import { ContactComponent } from "./contact/contact.component";
import { StoresComponent } from "./stores/stores.component";
import { LayoutModule } from "src/app/Layouts/layout.module";

@NgModule({
  declarations: [
    HomeComponent,
    AssistanceComponent,
    ContactComponent,
    StoresComponent,
  ],
  imports: [
    TranslationModule,
    CommonModule,
    GlobalModule,
    RouterLink,
    LayoutModule,
    AccueilSetyCoreComponent,
    AssistanceComponentBib,
    StoresComponentLib,
    ContactComponentLib,
    ChangePasswordComponent,
    ModalComponent,
    BrandsComponent,
    SnackbarComponent,
    AddProductPopupSetycoreComponent,
  ],
})
export class HomeModule {}
